import { render, staticRenderFns } from "./myInvoice.vue?vue&type=template&id=73bfd746&scoped=true"
import script from "./myInvoice.vue?vue&type=script&lang=js"
export * from "./myInvoice.vue?vue&type=script&lang=js"
import style0 from "./myInvoice.vue?vue&type=style&index=0&id=73bfd746&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bfd746",
  null
  
)

export default component.exports